import React, { useEffect, useState } from "react";
import s from "../PremiosMayores.module.css";

//assets
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import Pager from "../../../../Shared/Pagination/Pagination";
import masiveDistributionServices from "../../../../../api/delivery/masiveDistribution";

//Material
import {
  Button,
  CircularProgress,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
  Snackbar,
  Alert,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import AssessmentIcon from "@mui/icons-material/Assessment";
import Swal from "sweetalert2";
import { Currency } from "../../../../../helpers/currencyConvert";
import { dateFormats } from "../../../../../helpers/convertDate";
import { formatJavaCompletossx } from "../../../../../config/strings";
import useTranslationException from "../../../../../helpers/exceptions";

const cellStyles = {
  fontFamily: "Roboto, sans-serif",
  fontSize: ".9rem",
  fontWeight: "400",
  borderBottom: "1px solid rgba(0, 0, 0, 0.455)",
  cursor: "pointer",
};

const ConfirmTarasca = ({ file, setEdit, getFiles }) => {
  const { t, i18n } = useTranslation();
  const showExpetion = useTranslationException(t, i18n);
  const { textColor } = useSelector((state) => state.local);

  const [openError, setOpenError] = useState(false);

  const [items, setItems] = useState([]);

  //Paginado
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  const [pageCustom, setPageCustom] = useState(1);
  const { formatLocalDate } = dateFormats();

  const getItems = () => {
    setLoading(true);
    masiveDistributionServices
      .getDetailTarascaFile(page, pageSize, file?.data?.id)
      .then((res) => {
        setItems(res.content);
        setTotalPages(res.totalPages);
      })
      .then(() => setLoading(false))
      .catch((e) => {
        setOpenError(true);
        setLoading(false);
      });
  };

  useEffect(() => {
    getItems();
  }, [page, pageSize]);

  const handleConfirm = () => {
    Swal.fire({
      title: `${t("archiveConfirm")}: ${file?.data?.processedFile}`,
      text: `${t("archiveConfirmText")}`,
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#00A36C",
      cancelButtonColor: "#d33",
      confirmButtonText: t("confirm"),
      cancelButtonText: t("cancel"),
    }).then((result) => {
      if (result.isConfirmed) {
        let filename = file?.data?.processedFile;
        setLoading(true);
        masiveDistributionServices
          .confirmTarascaFile(filename)
          .then(() => {
            Swal.fire(t("archiveConfirmed"), "", "success");
          })
          .then(() => {
            setLoading(false);
            setEdit({ status: false, data: null });
            getFiles();
          })
          .catch((e) => {
            showExpetion.showErrorModalForServiceException(
              e,
              { icon: "warning" },
              t("anErrorOccurred,TryAgain"),
              t("sorryErrorOcurred"),
            );
            setLoading(false);
          });
      }
    });
  };

  return (
    <>
      <Grid container className={s.container}>
        <Grid item container xs={11} className={s.header}>
          <Grid item xs={1}>
            <ArrowBackIcon
              sx={{ fontSize: "2rem", color: "primary.main", mr: 1 }}
              onClick={() => {
                setEdit({ status: false, data: null });
                getFiles();
              }}
              className={s.arrow}
            />
          </Grid>
          <Grid
            item
            xs={11}
            md={11}
            lg={8}
            className={s.titleContainer}
            sx={{ justifyContent: "center" }}
          >
            <AssessmentIcon
              sx={{ fontSize: "2rem", color: "primary.main" }}
              className={s.icon}
            />
            <h4>{`${t("bigPricesDetail")}: [${file.data.serie}] ${file.data.gameName}`}</h4>
          </Grid>
          <Grid item xs={12} lg={2} className={s.filters}>
            <Button
              variant="contained"
              className={s.filterButton}
              sx={{ textTransform: "uppercase" }}
              onClick={handleConfirm}
              disabled={file?.data?.status === "Activo"}
            >
              <p>{t("confirm")}</p>
            </Button>
          </Grid>
        </Grid>
        {loading ? (
          <Grid item xs={11} className={s.loader}>
            <CircularProgress size={"3rem"} />
          </Grid>
        ) : items?.length ? (
          <Grid item container xs={11} className={s.data}>
            <TableContainer className={s.tableContainer}>
              <Table>
                <TableHead sx={{ backgroundColor: "primary.main" }}>
                  <TableCell
                    align="center"
                    sx={{
                      color: textColor,
                      fontSize: ".9rem",
                      fontWeight: 500,
                      fontFamily: "Roboto, sans-Serif",
                    }}
                  >
                    {t("controlCode")}
                  </TableCell>
                  <TableCell
                    align="center"
                    sx={{
                      color: textColor,
                      fontSize: ".9rem",
                      fontWeight: 500,
                      fontFamily: "Roboto, sans-Serif",
                    }}
                  >
                    {t("prizeCategory")}
                  </TableCell>
                  <TableCell
                    align="center"
                    sx={{
                      color: textColor,
                      fontSize: ".9rem",
                      fontWeight: 500,
                      fontFamily: "Roboto, sans-Serif",
                    }}
                  >
                    {t("value")}
                  </TableCell>
                  <TableCell
                    align="center"
                    sx={{
                      color: textColor,
                      fontSize: ".9rem",
                      fontWeight: 500,
                      fontFamily: "Roboto, sans-Serif",
                    }}
                  >
                    {t("ProcessDate")}
                  </TableCell>
                </TableHead>
                <TableBody>
                  {items?.map((item, i) => {
                    return (
                      <React.Fragment key={i}>
                        <TableRow
                          sx={{
                            "&:hover": { backgroundColor: "secondary.light" },
                          }}
                        >
                          <TableCell
                            align="center"
                            sx={{
                              ...cellStyles,
                              backgroundColor:
                                i % 2 === 0 ? "#dbdbdb76" : "#dbdbdd12",
                            }}
                          >
                            {item.controlNumber}
                          </TableCell>
                          <TableCell
                            align="center"
                            sx={{
                              ...cellStyles,
                              backgroundColor:
                                i % 2 === 0 ? "#dbdbdb76" : "#dbdbdd12",
                            }}
                          >
                            {item.prizeType}
                          </TableCell>
                          <TableCell
                            align="center"
                            sx={{
                              ...cellStyles,
                              backgroundColor:
                                i % 2 === 0 ? "#dbdbdb76" : "#dbdbdd12",
                            }}
                          >
                            <Currency value={item?.value} />
                          </TableCell>
                          <TableCell
                            align="center"
                            sx={{
                              ...cellStyles,
                              backgroundColor:
                                i % 2 === 0 ? "#dbdbdb76" : "#dbdbdd12",
                            }}
                          >
                            {formatLocalDate(
                              file.data.processedDate,
                              formatJavaCompletossx,
                            )}
                          </TableCell>
                        </TableRow>
                      </React.Fragment>
                    );
                  })}
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
        ) : (
          <Grid item xs={12} className={s.noResults}>
            {t("noResults")}
          </Grid>
        )}
        <Grid
          item
          xs={12}
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            mb: "50px",
          }}
        >
          <Pager
            pageSize={pageSize}
            setPageSize={setPageSize}
            page={page}
            setPage={setPage}
            totalPages={totalPages}
            pageCustom={pageCustom}
            setPageCustom={setPageCustom}
          />
        </Grid>
        <Snackbar
          open={openError}
          autoHideDuration={6000}
          onClose={() => setOpenError(false)}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "right",
          }}
        >
          <Alert
            variant="filled"
            onClose={() => setOpenError(false)}
            severity="error"
            sx={{ width: "100%" }}
          >
            {t("tryInOtherMoment")}
          </Alert>
        </Snackbar>
      </Grid>
    </>
  );
};

export default ConfirmTarasca;
